<template>
    <div
        class="error drop-message"
    >
        {{ message }}
    </div>
</template>

<script>
export default {
    name: "CDropMessage",

    props: {
        message: {

        }
    }
}
</script>

<style scoped>

.drop-message{
    position: absolute;
    width: 400px;
    height: 65px;
    z-index: 100;
    bottom: 10px;
    margin-left: calc(50% - 200px);
    border-radius: 6px;
    padding: 8px;
    text-align: center;
    color: white;
}

</style>